"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwButton = _interopRequireDefault(require("../../cwbutton/CwButton"));

var _CwLabel = _interopRequireDefault(require("../../cwlabel/CwLabel"));

var _CwNumberField = _interopRequireDefault(require("../../cwnumberfield/CwNumberField"));

var _reactPopper = require("react-popper");

var _CwDataGrid = _interopRequireDefault(require("../CwDataGrid.scss"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var NumberFilter =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(NumberFilter, _React$Component);
  (0, _createClass2.default)(NumberFilter, null, [{
    key: "formatNumber",
    value: function formatNumber(number) {
      var nf = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 20
      });
      return nf.format(number);
    }
  }, {
    key: "formatOnFocus",
    value: function formatOnFocus(value) {
      return value.split(',').join('');
    }
  }, {
    key: "getBlankFilterValue",
    value: function getBlankFilterValue() {
      return {
        minValue: null,
        maxValue: null
      };
    }
  }]);

  function NumberFilter() {
    var _this;

    (0, _classCallCheck2.default)(this, NumberFilter);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(NumberFilter).call(this));
    _this.state = {
      minValueFocused: false,
      maxValueFocused: false,
      showDropdown: false
    };
    _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(NumberFilter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.handleDocumentClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.handleDocumentClick);
    }
  }, {
    key: "onFilterChange",
    value: function onFilterChange(key, value) {
      this.props.onFilterChange(_objectSpread({}, this.props.filterValue, (0, _defineProperty2.default)({}, key, value)));
    }
  }, {
    key: "handleDocumentClick",
    value: function handleDocumentClick(event) {
      var numberFilter = (0, _reactDom.findDOMNode)(this.numberFilter);

      if (numberFilter && event.target instanceof Node && !numberFilter.contains(event.target) && event.target.className && typeof event.target.className === 'string' && !event.target.className.includes('CwDropdown-dropDownItem')) {
        this.setState({
          showDropdown: false
        });
      }
    }
  }, {
    key: "filterValueExists",
    value: function filterValueExists() {
      var returnValue = true;

      if (this.props.filterValue.minValue === null && this.props.filterValue.maxValue === null) {
        returnValue = false;
      }

      return returnValue;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement(_reactPopper.Manager, {
        ref: function ref(c) {
          _this2.numberFilter = c;
        }
      }, _react.default.createElement(_reactPopper.Target, null, _react.default.createElement(_CwButton.default, {
        cwId: "".concat(this.props.cwId, "_column_").concat(this.props.column.key, "_filter"),
        value: this.filterValueExists() ? '(change)' : '',
        className: _CwDataGrid.default.numberFilterButton,
        rightIcon: this.props.column.triggerIcon,
        onClick: function onClick() {
          _this2.setState({
            showDropdown: !_this2.state.showDropdown
          });
        }
      })), this.state.showDropdown && _react.default.createElement(_reactPopper.Popper, {
        placement: "bottom-start",
        style: {
          zIndex: 1
        },
        positionFixed: true
      }, _react.default.createElement("div", {
        className: _CwDataGrid.default.columnFilterDropdown
      }, _react.default.createElement("div", null, _react.default.createElement(_CwLabel.default, {
        "data-cwid": "".concat(this.props.cwId, "_min_value_label"),
        className: (0, _classnames.default)(_CwDataGrid.default.columnFilterDropdownHeader, (0, _defineProperty2.default)({}, _CwDataGrid.default.focused, this.state.minValueFocused)),
        value: "Minimum Value"
      }), _react.default.createElement(_CwNumberField.default, {
        cwId: "".concat(this.props.cwId, "_min_value_value"),
        style: {
          width: 120
        },
        value: this.props.filterValue.minValue,
        negative: "-",
        decimal: ".",
        thousands: ",",
        maxLength: 20,
        maxDecimalUnits: 3,
        placeholder: "Enter Value",
        formatNumber: NumberFilter.formatNumber,
        formatOnFocus: NumberFilter.formatOnFocus,
        onChange: function onChange(value) {
          _this2.onFilterChange('minValue', value);
        },
        onBlur: function onBlur() {
          _this2.setState({
            minValueFocused: false
          });
        },
        onFocus: function onFocus() {
          _this2.setState({
            minValueFocused: true
          });
        },
        autoFocus: true
      })), _react.default.createElement("div", {
        style: {
          marginTop: 38
        }
      }, _react.default.createElement(_CwLabel.default, {
        "data-cwid": "".concat(this.props.cwId, "_max_value_label"),
        className: (0, _classnames.default)(_CwDataGrid.default.columnFilterDropdownHeader, (0, _defineProperty2.default)({}, _CwDataGrid.default.focused, this.state.maxValueFocused)),
        value: "Maximum Value"
      }), _react.default.createElement(_CwNumberField.default, {
        cwId: "".concat(this.props.cwId, "_max_value_value"),
        style: {
          width: 120
        },
        value: this.props.filterValue.maxValue,
        negative: "-",
        decimal: ".",
        thousands: ",",
        maxLength: 20,
        maxDecimalUnits: 3,
        placeholder: "Enter Value",
        formatNumber: NumberFilter.formatNumber,
        formatOnFocus: NumberFilter.formatOnFocus,
        onChange: function onChange(value) {
          _this2.onFilterChange('maxValue', value);
        },
        onBlur: function onBlur() {
          _this2.setState({
            maxValueFocused: false
          });
        },
        onFocus: function onFocus() {
          _this2.setState({
            maxValueFocused: true
          });
        }
      })))));
    }
  }]);
  return NumberFilter;
}(_react.default.Component);

NumberFilter.propTypes = {
  cwId: _propTypes.default.string.isRequired,
  column: _propTypes.default.object.isRequired,
  filterValue: _propTypes.default.object.isRequired,
  onFilterChange: _propTypes.default.func.isRequired
};
var _default = NumberFilter;
exports.default = _default;